import { SKIPPER_VQ_LINK_NAME, SKIPPER_CQ_LINK_NAME, SKIPPER_CVQ_LINK_NAME } from './const'

import {
  skipperLinkAttributesToVirtualQuestion,
  skipperLinkVirtualQuestionAttributesFinalize
} from './link-types/virtual-question'
import {
  skipperLinkAttributesToCorrelationFinderQuestion,
  skipperLinkCorrelationFinderAttributesFinalize
} from './link-types/correlation-finder'
import {
  skipperLinkAttributesToCorrelationFinderVQQuestion,
  skipperLinkCorrelationFinderVQAttributesFinalize
} from './link-types/correlation-finder-vq'

import {
  SkipperLinkAttributes,
  SkipperLinkCorrelationFinderQuestion,
  SkipperLinkCompositeQuestion,
  SkipperLinkVirtualQuestion
} from './types'

export function skipperLinkAttributesToQuestion(
  attributes: SkipperLinkAttributes
): SkipperLinkCorrelationFinderQuestion | SkipperLinkVirtualQuestion | SkipperLinkCompositeQuestion {
  switch (attributes.questionType) {
    case 'vq': {
      return skipperLinkAttributesToVirtualQuestion(attributes)
    }
    case 'cq': {
      return skipperLinkAttributesToCorrelationFinderQuestion(attributes)
    }
    case 'cvq': {
      return skipperLinkAttributesToCorrelationFinderVQQuestion(attributes)
    }
    default: {
      return null
    }
  }
}

export function getAttributesFromLinkNode(node: Element): SkipperLinkAttributes {
  let attributes = Array.from(node.attributes).reduce((obj: SkipperLinkAttributes, attr) => {
    obj[attr.name] = attr.value
    return obj
  }, {})

  switch (node.tagName.toLowerCase()) {
    case SKIPPER_VQ_LINK_NAME: {
      attributes = skipperLinkVirtualQuestionAttributesFinalize(attributes)
      break
    }
    case SKIPPER_CQ_LINK_NAME: {
      attributes = skipperLinkCorrelationFinderAttributesFinalize(attributes)
      break
    }
    case SKIPPER_CVQ_LINK_NAME: {
      attributes = skipperLinkCorrelationFinderVQAttributesFinalize(attributes)
      break
    }
    default: {
      break
    }
  }

  return attributes
}

export function collectArrayFromAttributes(
  attributes: SkipperLinkAttributes,
  prefix: string,
  keys: string[],
  mandatoryKeys: string[] = keys
): { [key: string]: string }[] {
  const collected: { [key: string]: string }[] = []
  for (let i = 0; ; i++) {
    const attributeKeys = keys.map(key => `${prefix}${i}-${key}`)
    const mandatoryAttributeKeys = mandatoryKeys.map(key => `${prefix}${i}-${key}`)
    if (mandatoryAttributeKeys.some(key => !(key in attributes))) {
      break
    }
    const item = keys.reduce(
      (variants, key, index) => {
        variants[key] = attributes[attributeKeys[index]]
        return variants
      },
      {} as { [key: string]: string }
    )
    collected.push(item)
  }
  return collected
}
